import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { BlogPost } from '../domain';
import { PostShareButtonComponent } from '../ui-post-share-button/post-share-button.component';
@Component({
  selector: 'rma-blog-post-preview',
  templateUrl: './post-preview.component.html',
  styleUrls: ['./post-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, LazyLoadImageModule, PostShareButtonComponent, DatePipe],
})
export class PostPreviewComponent {
  @Input()
  public blog: BlogPost;

  @Input()
  public thumbnailSize: string;

  public get optimalImgSrc(): string {
    return this.blog?.featuredMedia?.sizes[this.thumbnailSize]?.SourceUrl ?? this.blog?.featuredMedia?.sizes?.full?.sourceUrl ?? '';
  }
}
